module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-remark-autolink-headers@5.24.0_gatsby@4.24.5_babel-eslint@10.1.0_eslint@7.32.0___9391e1f61caf5d3b575ceb3dee96085b/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"offsetY":0,"className":"anchor"},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@4.24.5_babel-eslint@10.1.0_eslint@7.32.0__encoding@0.1.13_react-dom@16.14.0_reac_6edac2efae7db184c15b4a54f0f9e8f3/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
